<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

const { t } = useI18n();
const currentChat = useMapGetter('getSelectedChat');
const now = ref(Date.now());
let timer;

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onUnmounted(() => {
  window.clearInterval(timer);
});

const redistribution = computed(() => currentChat.value?.redistribution);

const visible = computed(() => Boolean(redistribution.value));

const secondsLeft = computed(() => {
  const dueAt = redistribution.value?.due_at;
  if (!dueAt) return redistribution.value?.seconds_until_due ?? 0;
  return Math.max(0, Math.ceil((new Date(dueAt).getTime() - now.value) / 1000));
});

const label = computed(() => {
  const state = redistribution.value?.state;
  if (state === 'stalled') {
    return t('ASSIGNMENT_REDISTRIBUTION.STALLED');
  }
  if (state === 'covered') {
    return t('ASSIGNMENT_REDISTRIBUTION.COVERED');
  }
  if (state === 'due' || secondsLeft.value <= 0) {
    return t('ASSIGNMENT_REDISTRIBUTION.DUE');
  }
  const minutes = Math.floor(secondsLeft.value / 60);
  const seconds = secondsLeft.value % 60;
  return t('ASSIGNMENT_REDISTRIBUTION.SCHEDULED', {
    time: `${minutes}:${String(seconds).padStart(2, '0')}`,
  });
});

watch(
  () => currentChat.value?.id,
  () => {
    now.value = Date.now();
  }
);
</script>

<template>
  <div
    v-if="visible"
    class="mx-4 mb-2 rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm text-n-slate-12"
    data-testid="assignment-redistribution-banner"
  >
    {{ label }}
  </div>
</template>
